/* eslint-disable jsx-a11y/anchor-is-valid */
import { MenuComponent } from '_metronic/assets/ts/components'
import clsx from 'clsx'
import { useEffect } from 'react'

export interface ActionCellProps {
  row: any
  onReturnDefective: (row: any) => void
}

const ActionCell: React.FC<ActionCellProps> = ({ row, onReturnDefective }) => {
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  return (
    <>
      <a
        className='btn btn-icon btn-custom btn-active-light rounded-circle'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'>
        <img src='/media/icons/dots-vertical.png' alt='Dot Vertical Icon' width={20} height={20} />
      </a>
      <div
        className={clsx(
          'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-175px py-4'
        )}
        data-kt-menu='true'>
        <div className='menu-item px-3' data-kt-menu-dismiss='true'>
          <a
            className='menu-link px-3 d-flex align-items-center flex-row'
            onClick={() => onReturnDefective(row)}>
            <div className='text-kumopack-grey-700' style={{ marginTop: '0.1rem' }}>
              ส่งคืนเสาเสีย
            </div>
          </a>
        </div>
      </div>
    </>
  )
}

export default ActionCell
